import { render, staticRenderFns } from "./MakeACall.vue?vue&type=template&id=4cc4c7f3&"
import script from "./MakeACall.vue?vue&type=script&lang=js&"
export * from "./MakeACall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports